import { useIntl } from 'react-intl'

import Button from 'shared/ui/Button_2'

import { ButtonWrapper, Container, Image, Title } from './Style'
import templates from './assets/templates.png'

type SwitchTemplateProps = {
  onButtonClick: () => void
}

const SwitchTemplate: React.FC<SwitchTemplateProps> = ({
  onButtonClick
}) => {
  const { formatMessage } = useIntl()

  return (
    <Container>
      <Title>
        {formatMessage({
          id: 'Panel.coverStartEditing.switchTemplate.title'
        })}
      </Title>
      <Image src={templates} />
      <ButtonWrapper>
        <Button
          size="md"
          textId="Panel.coverStartEditing.switchTemplate.button"
          intent="secondary-base"
          onPress={onButtonClick}
        />
      </ButtonWrapper>
    </Container>
  )
}

export default SwitchTemplate
